import React, { useState } from 'react';
import { ProductPriceString } from '../utils/ProductPriceString';
import { successTickImageUrl } from '../utils/Constants';
import AdditionalOptions from './AdditionalOptionsCollection';
import CompatioAnalytics from '../../api/CompatioAnalytics';
import ProductAddToCart from '../utils/ProductAddToCartPop';
import GalleryMedia from './GalleryMedia';

export const ProductCollectionFilter = ({
  parentProduct,
  isReelAdded,
  optionsDetails,
  setOptionsDetails,
  productDetails,
  popupType,
  isParentReel,
  popCloseBox,
}) => {
  const [selectedVariant, setSelectedVariant] = useState(
    parentProduct.variants.filter(e => e.available !== false)[0].variantID
  );
  const images = parentProduct.images.map(image => ({
    original: image,
    thumbnail: image,
  }));
  const isSimpleProduct = parentProduct.variants.length <= 1;

  const handleSelectVariantChange = event => {
    const selectedValue = event.target.value;
    setSelectedVariant(selectedValue);
    const selectedFilterVariant = parentProduct.variants.find(

      variant => variant.id === +selectedValue
    );
     selectedFilterVariant.priceNew =parentProduct.priceNew;
     selectedFilterVariant.featured_image =parentProduct.featured_image;
    console.log(selectedFilterVariant,parentProduct,'selectedFilterVariantFilter')
    window.compatioConfig.compatibleProducts.methods.handleChangeProductSku(
      selectedValue
    );
    window.compatioConfig.compatibleProducts.methods.handleProductDataUpdate(
      selectedFilterVariant
    );
    window.compatioConfig.compatibleProducts.methods.handleProductDataUpdateVariantLevel(
      selectedFilterVariant
    );
  };

  return (
    <>
      <compatibleQuickRecomended parentProductCollection={parentProduct} />
      <div className="content">
        <div className="compatio-collection-pop">
          <div className="compatio-collection-pop-img">
            <GalleryMedia title={parentProduct.title} items={images} />
          </div>

          <div
            className="compatio-collection-pop-data"
            data-testid="productname"
          >
            <div className="product-block product-block--header">
              <div className="product-single__vendor">
                {parentProduct.productVendor}
              </div>
              <p
                className="xrs-product-name-text h2 product-single__title"
                id="xcs-parentname"
              >
                {parentProduct.title}
              </p>
            </div>

            <p id="xcs-parent-price">
              <div className="grid-product__price">
                {parentProduct.compare_at_price > parentProduct.price ? (
                  <>
                    <span className="grid-product__price--original">
                      {parentProduct.compareOriginalPrice + ' '}
                    </span>
                    <span className="visually-hidden">
                      {parentProduct.priceNew + ' '}
                    </span>
                    <span className="grid-product__price--savings">
                      Save {' ' + parentProduct.salePrice}
                    </span>
                  </>
                ) : (
                  <div className="grid-product__price">
                    {parentProduct.priceNew}
                  </div>
                )}
              </div>
              <div className="product__policies rte small--text-center">
                <a href="/policies/shipping-policy">Shipping</a> calculated at
                checkout.
              </div>
            </p>
            <div className="product-block">
              <hr />
            </div>
            <div className="xrs-select-wrapper" data-testid="product_selection">
              <div className="product-block" data-dynamic-variants-enabled="">
                <div
                  className="variant-wrapper variant-wrapper--dropdown js"
                  data-type="dropdown"
                >
                  <label
                    className="variant__label"
                    htmlFor="SingleOptionSelector-template--16023999905967__main-6145590198447-option-0-modal"
                  >
                    {!isSimpleProduct ? 'Size' : null}
                  </label>
                  <div
                    className="variant-input-wrap"
                    data-index="option1"
                    data-handle="size"
                  >
                    {!isSimpleProduct && (
                      <select
                        value={selectedVariant}
                        onChange={handleSelectVariantChange}
                        className="xrsselect-custon"
                      >
                        {parentProduct.variants.map(variant => (
                          <option
                            key={variant.id}
                            value={variant.id}
                            className="xrs-product__option-text"
                            disabled={!variant.available}
                          >
                            {variant.title}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  {isParentReel && (
                    <AdditionalOptions
                      optionsDetails={optionsDetails}
                      setOptionsDetails={setOptionsDetails}
                      productDetails={productDetails}
                      popupType={popupType}
                      isParentReel={isParentReel}
                    />
                  )}
                </div>
              </div>
              <ProductAddToCart
                _singleProduct={parentProduct}
                _variantId={selectedVariant}
                _baseItemId={selectedVariant}
                _userId={CompatioAnalytics.getUserId()}
                _singleProductName={parentProduct.title}
                _singleProductImage={parentProduct.featured_image}
                _singleProductPrice={parentProduct.price}
                isReel=""
                _singleProductCat={parentProduct.type}
                isreeladded={isReelAdded}
                xrsuserid={CompatioAnalytics.getUserId()}
                reelid={
                  isReelAdded === 'true'
                    ? productDetails.variantId
                      ? productDetails.variantId
                      : productDetails.merchantProductSku
                    : '-1'
                }
                additionaloptions={
                  isParentReel
                    ? optionsDetails.details !== undefined && isReelAdded
                      ? JSON.stringify(optionsDetails.details)
                      : ''
                    : ''
                }
                backingproduct={
                  isParentReel
                    ? optionsDetails.backingProduct !== undefined && isReelAdded
                      ? optionsDetails.backingProduct
                      : ''
                    : ''
                }
                popCloseBox={popCloseBox}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// export default ProductCollectionFilter;
